export default "/static/explore/86f255d8923c60e93c55378a783a789bb15b2d64/_next/static/images/reminders-default-bg-c895cd003dffc5cebf1fcdc4cf38526b.jpg";